module.exports = __webpack_public_path__ + "img/image.b908bec1.svg";